import { SettingConst } from '@faire/web-api--source/types';

/**
 * Enable sign up animation to show during the sign up flow
 */
export const SHOW_SIGN_UP_ANIMATION_240430 =
  'SHOW_SIGN_UP_ANIMATION_240430' as SettingConst<
    'SHOW_SIGN_UP_ANIMATION_240430',
    boolean,
    'RETAILER' | 'VISITOR_WEB'
  >;
